module.exports = __webpack_public_path__ + "static/media/react1jest.5e13da10.png";